import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Tooltip } from 'antd';
import _ from 'lodash';
import styles from './styles.scss';

const CheckBoxAttribute = props => (
  <div className={styles.row}>
    <div className={styles.header}>
      <Switch
        style={{
          cursor: props.default.isEditAccess ? 'pointer' : 'unset',
        }}
        size="default"
        className={styles.switch}
        checked={props.value}
        onChange={value => {
          props.onChange(value);
          props.onSave();
        }}
      />
      <div className={styles.caption}>
        <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
          <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
        </Tooltip>
      </div>
    </div>
  </div>
);

CheckBoxAttribute.propTypes = {
  default: PropTypes.objectOf(PropTypes.any).isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
};

CheckBoxAttribute.defaultProps = {
  value: false,
};

export default CheckBoxAttribute;
